import uuidv4 from "uuid/v4";
import createAxiosClient from "../clients/axiosClient";

const sessionId = uuidv4();

const faqClient = async (isServer, extraHeaders = {}) => {
  const endpoint = isServer
    ? `http://${process.env.NEXT_PUBLIC_ENVIRONMENT_NAME}-help-answers/v1`
    : `${process.env.NEXT_PUBLIC_API_DOMAIN}/customer-help/faq/v1`;

  const faqAxiosClient = await createAxiosClient({
    baseURL: endpoint,
    headers: {
      "X-JLP-CUSTOMER-HELP-FAQ-SESSION-ID": sessionId,
      ...extraHeaders,
    },
  });

  return faqAxiosClient;
};

export default faqClient;
